import { render, staticRenderFns } from "./footer-evsa.vue?vue&type=template&id=f6a9af2c&scoped=true&"
import script from "./footer-evsa.vue?vue&type=script&lang=js&"
export * from "./footer-evsa.vue?vue&type=script&lang=js&"
import style0 from "./footer-evsa.vue?vue&type=style&index=0&id=f6a9af2c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6a9af2c",
  null
  
)

export default component.exports